import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const PROFILE_PICTURE_SIZE_BREAK_POINT = 40;
const CustomPicture = (props) => {
    let imageStyle = {};
    let imageClass = (props.className || "") + " rounded-circle av-profile-image";
    if (typeof props.size === "number") {
        imageStyle = { width: props.size, height: props.size };
        if (props.size < 40) {
            imageStyle = Object.assign(Object.assign({}, imageStyle), { fontSize: props.size / 2 });
        }
        if (props.size > PROFILE_PICTURE_SIZE_BREAK_POINT) {
            imageClass += "-lg";
        }
    }
    else if (props.size === "lg") {
        imageClass += "-lg";
    }
    return (_jsx("div", { className: imageClass + " d-flex justify-content-center flex-column bg-secondary", style: imageStyle, 
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        title: props.title, children: props.children }));
};
const TextWithCircleBackground = (props) => {
    return (_jsx(CustomPicture, { size: props.size, className: props.className, title: props.title, children: props.children }));
};
export default TextWithCircleBackground;
